import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: [],
  total: 0,
  pages: 0,
  success: false,
  error: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsersData: (state, action) => {
      const { users, total, pages } = action.payload.data;
      state.users = users;
      state.total = total;
      state.pages = pages;
      state.success = action.payload.success;
      state.error = action.payload.error;
    },

    clearUsers: (state) => {
      state.users = [];
      state.total = 0;
      state.pages = 0;
      state.success = false;
      state.error = null;
    },

    addUser: (state, action) => {
      state.users.push(action.payload);
      state.total += 1;
    },

    updateUser: (state, action) => {
      const index = state.users.findIndex(
        (user) => user.id === action.payload.id
      );
      if (index !== -1) {
        state.users[index] = action.payload;
      }
    },

    deleteUser: (state, action) => {
      state.users = state.users.filter(
        (user) => user.id !== action.payload
      );
      state.total -= 1;
    },
  },
});

export const {
  setUsersData,
  clearUsers,
  addUser,
  updateUser,
  deleteUser,
} = usersSlice.actions;

export default usersSlice.reducer;